var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--freemium-incompatible-modal"
  }, [_c('general-modal', {
    attrs: {
      "modal-id": "freemium-modal",
      "hasCloseButton": true,
      "modalView": _vm.viewModal,
      "height": "unset"
    },
    on: {
      "onPressClose": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "tw-px-4",
    attrs: {
      "data-testid": "freemium-incompatible-modal"
    }
  }, [_c('nuxt-img', {
    staticClass: "w-auto tw-block tw-mx-auto tw-mb-6",
    attrs: {
      "src": "/assets/images/freemium/freemium-incompatible.svg",
      "alt": "Freemium Incompatible",
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "tw-text-7 tw-font-semibold tw-text-primary tw-my-6 tw-mx-auto tw-block tw-text-center"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('components.freemium.get-the-app')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tw-my-6 tw-py-6 tw-text-14 tw-leading-[20px] tw-border-0 tw-border-t tw-border-b tw-border-solid tw-border-zinc-150"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('components.freemium.get-the-app-description')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-justify-between tw-items-center tw-pb-6"
  }, [_c('nuxt-img', {
    staticClass: "tw-w-[65px] tw-h-[65px] tw-hidden md:tw-inline",
    attrs: {
      "src": "/assets/images/freemium/freemium-app-store-qr.svg",
      "alt": "Freemium App Store QR",
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "tw-flex",
    attrs: {
      "target": "_blank",
      "rel": "noopener",
      "href": "https://apps.apple.com/app/airalo-esim-store/id1475911720"
    }
  }, [_c('nuxt-img', {
    staticClass: "tw-w-[160px] tw-h-[46px]",
    attrs: {
      "src": "/assets/images/freemium/appstore.svg",
      "alt": "Freemium App Store QR",
      "loading": "lazy"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "tw-flex",
    attrs: {
      "target": "_blank",
      "rel": "noopener",
      "href": "https://play.google.com/store/apps/details?id=com.mobillium.airalo"
    }
  }, [_c('nuxt-img', {
    staticClass: "tw-w-[160px] tw-h-[46px]",
    attrs: {
      "src": "/assets/images/freemium/googleplay.svg",
      "alt": "Freemium App Store QR",
      "loading": "lazy"
    }
  })], 1), _vm._v(" "), _c('nuxt-img', {
    staticClass: "tw-w-[65px] tw-h-[65px] tw-hidden md:tw-inline",
    attrs: {
      "src": "/assets/images/freemium/freemium-google-play-qr.svg",
      "alt": "Freemium App Store QR",
      "loading": "lazy"
    }
  })], 1)], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }